import {
  IonButtons,
  IonContent,
  IonHeader,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar,
  IonCol,
  IonRow,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonGrid,
  useIonViewDidEnter,
} from "@ionic/react";
import { useParams } from "react-router";
import ExploreContainer from "../components/ExploreContainer";
import {
  Descriptions,
  Row,
  Col,
  notification,
  message,
  Table,
  Tag,
  Dropdown,
  Menu,
  Modal,
} from "antd";
import { Card } from "antd";
import { Switch } from "antd";
import { Input } from "antd";
import moment from "moment";
import { PageHeader } from "antd";
import "./Page2.css";
import { DownloadOutlined } from "@ant-design/icons";
import createRowData from "../components/createRowData";
import { SearchOutlined } from "@ant-design/icons";
import { DatePicker, Space } from "antd";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useDemoData } from "@mui/x-data-grid-generator";
import { DataGrid, GridCellParams, GridToolbar } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { makeStyles } from "@mui/material/styles";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Select from "@mui/material/Select";
import { seedValue } from "faker";

const Users: React.FC = (props: any) => {
  const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    backdrop: {
      background: "black",
      zIndex: theme.zIndex.drawer + 1,
      color: "#fff",
    },
  }));

  const classes = useStyles();

  const [open, setOpen] = useState(true);
  const [rejectionReason, setRejectionReason] = useState("");
  const [currentUser, setCurrentUser] = useState("");
  const [enteredstatus, setEnteredStatus] = useState("");
  const [isModalAcceptedVisible, setIsAcceptedModalVisible] = useState(false);
  //const [enteredVerification, setEnteredVerification] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);

  const statusChangeHandler = (event: any, user: any) => {
    setEnteredStatus(event.target.value);
    setCurrentUser(event.target.value);
    //console.log("statuschange");
    //console.log(enteredstatus);
    setCurrentUser(user);

    if (event.target.value === "Accepted") {
      showAcceptModal();
    } else {
      showModal();
    }
  };
  /*
    const verificationChangeHandler = (event: any) => {
        setEnteredVerification(event.target.value);
    };
*/
  useEffect(() => {}, [currentUser]);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const showAcceptModal = () => {
    setIsAcceptedModalVisible(true);
  };

  const handleChange = (event: any) => {
    setRejectionReason(event.target.value);
  };

  const handleOk = () => {
    setIsModalVisible(false);
    setIsAcceptedModalVisible(false);
    UpdateUsers();
  };

  const handleBackDropClose = () => {
    setOpen(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  async function UpdateUsers() {
    /* @ts-ignore */
    let tempUser = currentUser;

    console.log(currentUser);
    /* @ts-ignore */
    tempUser.ProfileStatus = enteredstatus;
    /* @ts-ignore */
    tempUser.RejectionReason = rejectionReason;
    setRejectionReason("");
    console.log(tempUser);

    try {
      axios({
        method: "post",
        url: "https://dev.northroom.co.za/api/bizprop/users/client/save",
        data: tempUser,
      })
        .then(function (response) {
          //handle success
          console.log(response);
        })
        .catch(function (response) {
          //handle error
          console.log(response);
        });
    } catch (error) {
      console.error(error.response.data);
    }
  }
  const columns = [
    { field: "id", headerName: "ID", width: 170 },
    { field: "Name", headerName: "NAME", width: 170 },
    { field: "Email", headerName: "EMAIL", width: 170 },
    { field: "ContactNo", headerName: "CONTACT", width: 170 },
    {
      field: "RejectionReason",
      headerName: "REASON FOR REJECTION",
      width: 270,
    },
    { field: "UserType", headerName: "USER TYPE", width: 170 },
    {
      field: "ProfileStatus",
      headerName: "PROFILE STATUS",
      width: 190,
      renderCell: (params: GridCellParams) => (
        <strong>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            style={{ width: "180px" }}
            onChange={(e) => statusChangeHandler(e, params.row)}
            value={params.value}
          >
            <MenuItem value={"Accepted"}>Accepted</MenuItem>
            <MenuItem value={"Rejected"}>Rejected</MenuItem>
          </Select>
        </strong>
      ),
    },
    /*
        {
            field: 'VerifiedStatus', headerName: 'VERIFICATION STATUS', width: 190,
            renderCell: (params: GridCellParams) => (<strong>


                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    style={{ width: "180px" }}
                    onClick={verificationChangeHandler }
                    value={enteredVerification}

                >
                    <MenuItem value={"Blocked"}>Accepted</MenuItem>
                    <MenuItem value={"Unblocked"}>Rejected</MenuItem>
                </Select>
            </strong>),
        },
        */
  ];

  const [data1, SetData] = useState([]);

  useIonViewDidEnter(() => {
    axios
      .get("https://dev.northroom.co.za/api/bizprop/users/all")
      .then(function (response) {
        // handle success
        //console.log(response.data);
        SetData(response.data);
        handleBackDropClose();
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
      .then(function () {
        // always executed
      });
  });

  return (
    <IonPage>
      <Backdrop
        className={classes.backdrop}
        open={open}
        transitionDuration={1500}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonRow>
            <PageHeader className="site-page-header" title="Users" />
          </IonRow>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        <Space direction="vertical">
          <IonGrid>
            <IonRow>
              <IonCol size="11" style={{ paddingLeft: "2vw", paddingRight: "5vw" }}>
                <IonCard>
                  <IonCardHeader>
                    <Modal
                      title="Reason for Rejection"
                      visible={isModalVisible}
                      onOk={handleOk}
                      onCancel={handleCancel}
                    >
                      <Space direction="vertical">
                        <Input
                          value={rejectionReason}
                          onChange={handleChange}
                          style={{ width: "240%" }}
                          type ="text"
                          placeholder="Provide a reason for rejection"
                        />
                      </Space>
                      <hr></hr>
                    </Modal>
                    <Modal
                      title="Accepted"
                      visible={isModalAcceptedVisible}
                      onOk={handleOk}
                      onCancel={handleCancel}
                    >
                      <Space direction="vertical">
                        {/* @ts-ignore */}
                        <p>Accepted {currentUser.Name}</p>
                      </Space>
                    </Modal>
                  </IonCardHeader>

                  <IonCardContent>
                    <div
                      style={{
                        height: 400,
                        width: "80vw",
                        paddingRight: "7.5vw",
                      }}
                    >
                      <DataGrid
                        rows={data1}
                        columns={columns}
                        components={{
                          Toolbar: GridToolbar,
                        }}
                        filterModel={{
                          items: [
                            {
                              columnField: "Name",
                              operatorValue: "contains",
                              value: "",
                            },
                          ],
                        }}
                      />
                    </div>
                  </IonCardContent>
                </IonCard>
              </IonCol>
            </IonRow>
          </IonGrid>
        </Space>
      </IonContent>
    </IonPage>
  );
};

export default Users;
